import { Component, h, Prop, Listen, Element } from '@stencil/core';
import { PageNode } from 'interfaces/PageNode';
import { _BREAKPOINTS_ } from 'utils';

@Component({
    tag: 'kdx-mega-nav',
    styleUrl: 'kdx-mega-nav.scss',
    shadow: false
})
export class KdxMegaNav {

    @Element() root: HTMLElement;

    @Prop() pageNodes: string = '';
    pageNodeArray: Array<PageNode> = [];

    @Prop() utilityNavLinks: string = '';
    utilityNavLinkArray: Array<PageNode> = [];

    /* When event is emitted from alert close, recalculate nav positions*/
	@Listen('dismissTriggered', {target: 'window'})
	handleDismissTriggered() {
        setTimeout(() => {
            this.calculateNavPositions();
        }, 50);
	}

    @Listen('click', {target: 'window'})
    handleToggleClick(event: MouseEvent) {
        const toggle = (event.target as HTMLElement).closest('.app-nav__parent-toggle');
        if(!toggle) return; 

        const parent = toggle.parentElement;
        const subNav = parent.nextElementSibling;
        const isOpen = subNav.classList.contains('open');
        const currentOpen = document.querySelector('.app-nav__sub.open');

        
        if(toggle) {
            toggle.addEventListener('click', () => {

                if(currentOpen && currentOpen !== subNav) {
                    currentOpen.classList.remove('open');
                    currentOpen.setAttribute('aria-expanded', 'false');
                    toggle.setAttribute('aria-expanded', 'false');
                }
                if(isOpen) {
                    subNav.classList.remove('open');
                    subNav.setAttribute('aria-expanded', 'false');
                    toggle.setAttribute('aria-expanded', 'false');
                    document.querySelector('body').classList.remove('menu-entered');
    
                } else {
                    subNav.classList.add('open');
                    subNav.setAttribute('aria-expanded', 'true');
                    document.querySelector('body').classList.add('menu-entered');
                    toggle.setAttribute('aria-expanded', 'true');
                    document.querySelector('body').classList.add('menu-entered');
                }
            })
        }

    }

    /*Recalculate nav positions on screen resize*/
    @Listen('resize', { target: 'window' })
    handleScreenResize() {
        this.calculateNavPositions();
    }

    @Listen('mouseenter', {capture: true})
    handleHoverIn(event: MouseEvent) {
        if(window.innerWidth > _BREAKPOINTS_["lg"]) {

            const navNode = (event.target as HTMLElement).closest('.app-nav__node') as HTMLElement;
    
            if (!navNode) return;
    
            const toggle = navNode.querySelector('.app-nav__parent-toggle');
            const subNav = navNode.querySelector('.app-nav__sub');
    
            if (navNode && toggle && subNav) {
                navNode.classList.add('open');
                subNav.classList.add('open');
                toggle.setAttribute('aria-expanded', 'true');
                document.querySelector('body').classList.add('menu-entered');

                navNode.addEventListener('mouseleave', this.handleHoverOut);
            }
        }
    }

    handleHoverOut = (event: MouseEvent) => {
        if(window.innerWidth > _BREAKPOINTS_["lg"]) {
            const navNode = event.currentTarget as HTMLElement;
            const subNav = navNode.querySelector('.app-nav__sub');
            if (!navNode) return;

            if (event.relatedTarget && (navNode.contains(event.relatedTarget as Node) || subNav.contains(event.relatedTarget as Node))) {
                return;
            }

            navNode.classList.remove('open');
            subNav.classList.remove('open');
    
            const toggle = navNode.querySelector('.app-nav__parent-toggle');

            if (toggle) {
                toggle.setAttribute('aria-expanded', 'false');
            }
    
            document.querySelector('body')?.classList.remove('menu-entered');

            navNode.removeEventListener('mouseleave', this.handleHoverOut);
        }
    }

    @Listen('keydown', {target: 'window'})
    toggleKeydown(event: KeyboardEvent) {
        const toggle = (event.target as HTMLElement).closest('.app-nav__parent-toggle');
            if(!toggle) return; 

            const parent = toggle.parentElement;
            const subNav = parent.nextElementSibling;
            const isOpen = subNav.classList.contains('open');
            const currentOpen = document.querySelector('.app-nav__sub.open');

        if(event.key === 'Enter') {

            if(currentOpen && currentOpen !== subNav) {
                currentOpen.classList.remove('open');
                currentOpen.setAttribute('aria-expanded', 'false');
                toggle.setAttribute('aria-expanded', 'false');
            }

            if(isOpen) {
                subNav.classList.remove('open');
                subNav.setAttribute('aria-expanded', 'false');
                toggle.setAttribute('aria-expanded', 'false');
                document.querySelector('body').classList.remove('menu-entered');

            } else {
                subNav.classList.add('open');
                subNav.setAttribute('aria-expanded', 'true');
                document.querySelector('body').classList.add('menu-entered');
                toggle.setAttribute('aria-expanded', 'true');
                document.querySelector('body').classList.add('menu-entered');
            }
        }
        if (event.key === 'Tab' && event.shiftKey && currentOpen) {
            const focusedElement = document.activeElement as HTMLElement;
            const currentToggle = currentOpen.closest('.app-nav__node')
                ?.querySelector('.app-nav__parent-toggle') as HTMLElement;
    
            if (!currentOpen.contains(focusedElement)) {
                currentOpen.classList.remove('open');
                currentOpen.setAttribute('aria-expanded', 'false');
                currentToggle?.setAttribute('aria-expanded', 'false');
                document.body.classList.remove('menu-entered');
            }
        }
    }
    
    componentWillLoad() {
        if (this.pageNodes !== '') {
            this.pageNodeArray = JSON.parse(this.pageNodes);
        }

        if (this.utilityNavLinks !== '') {
            this.utilityNavLinkArray = JSON.parse(this.utilityNavLinks);
        }

        this.enableStickyNav();
    }

    componentDidRender() {
        this.toggleMobileNav();
        this.toggleDesktopSearch();
        this.toggleLogin();
        this.calculateNavPositions();
        this.handleDismissTriggered();
    }

    createChildrenMarkup(children: Array<PageNode>) {
        let output = '';
        let isStartOfCol = true;

        children.forEach((child) => {
            if (isStartOfCol) {
                if (children.some(child => child.Break === 'true')) {
                    output += '<div class="col col-12 col-xl-4">';
                }
                else {
                    output += '<div>';
                }
                isStartOfCol = false;
            }

          output += `<div class="app-nav__child">`;
            if(child.UrlName) {
                output +=  `<a href="${child.UrlName}" class="${(child.LinkSpeedbump ? 'speedbump-link' : '')}" target="${child.LinkNewTab ? '_blank' : ''}" aria-label="${child.Title}">
                                ${child.Title}
                            </a>`
            } else {
                output += `<div>${child.Title}</div>`;
            }

            output += `</div>`; 

            if (child.Nodes && child.Nodes.length) {
                output += '<div class="app-nav__third-level">';

                child.Nodes.forEach((thirdLevel) => {
                    output += `<div>
                        <a href="${thirdLevel.UrlName}" class="${(thirdLevel.LinkSpeedbump ? 'speedbump-link' : '')}" target="${thirdLevel.LinkNewTab ? '_blank' : ''}" aria-label="${thirdLevel.Title}">
                          ${thirdLevel.Title}
                          <kdx-icon icon="thin-chevron"></kdx-icon>
                        </a>
                      </div>`;
                });

                output += '</div>';
            }

            if (child.Break && child.Break == 'true') {
                output += '</div>';
                isStartOfCol = true;
            }
        });

        return output;
    }

    hasThirdLevel(children : Array<PageNode>) {
        var thirdLevels = children.filter((child) => {
            return child.Nodes && child.Nodes.length;
        });

        return thirdLevels.length > 0;
    }

    menuEntered(state) {
        if (state == 'enter') {
            if (globalThis.closeOlb) {
                globalThis.closeOlb();
            }
        } 
    }
    
    enableStickyNav() {
        const header = document.querySelector('.site-header__nav');
        
        if (!header) {
            return;
        }

        let isSticky = false;

        const headerPos = window.scrollY + header.getBoundingClientRect().top;
        
        window.addEventListener('scroll', () => {
            if (window.scrollY > (headerPos + 200) && !isSticky) {
                document.querySelector('body').classList.add('sticky-nav');
                isSticky = true;
            } else if (isSticky && window.scrollY < (headerPos + 200)) {
                document.querySelector('body').classList.remove('sticky-nav');
                isSticky = false;
            }
        });
    }

    mobileNavToggle(level: string, nodeIndex: number, childIndex: number = null) {
        const levels = {
            '1': '.app-nav__node',
            '2': '.app-nav__child'
        };

        let target = null;

        if (level == '1') {
            target = document.querySelectorAll('.app-nav__node')[nodeIndex];
        } else if (level == '2') {
            target = document.querySelectorAll('.app-nav__node')[nodeIndex].querySelector('.app-nav__children-mobile').querySelectorAll('.app-nav__child')[childIndex];
        }

        if (target) {
            target.classList.add('changing');

            document.querySelectorAll(levels[level]).forEach((node: HTMLElement) => {
                if (!node.classList.contains('changing')) {
                    node.classList.remove('open');
                }
            });

            target.classList.toggle('open');
            target.classList.remove('changing');
        }
    }

    calculateNavPositions() {
        var header: HTMLElement = document.querySelector('.site-header');
        var nav: HTMLElement = document.querySelector('.app-nav');
        var searchBar: HTMLElement = document.querySelector('.site-header__utils');
        var utilLinks: HTMLElement = document.querySelector('.header-util-nav-links');
        const fdic: HTMLElement = document.querySelector('.fdic__container');
        var loginFormWrap: HTMLElement = document.querySelector('#login-wrapper');
        var alertBanners: NodeListOf<HTMLElement> = document.querySelectorAll('.alert-banner');
        var loginFormWrap = document.querySelector('#login-wrapper') as HTMLElement;
        
        //Get element heights
        var windowHeight = window.innerHeight;
        var headerHeight = header?.getBoundingClientRect().height;
        var searchHeight = searchBar?.getBoundingClientRect().height;
        let fdicHeight = fdic?.getBoundingClientRect().height;
        let alertBannersHeight = 0;

        if (!nav || !searchBar || !header) {
            return;
        }

        //Set util links mobile-offest value if notification banner is open
        if (alertBanners) {
            alertBanners.forEach((banner) => {
                alertBannersHeight += banner.getBoundingClientRect().height;
            });
            var mobileNavOffsetBannerShown = (headerHeight + searchHeight) - alertBannersHeight - fdicHeight;

            nav.style.top = mobileNavOffsetBannerShown + 'px';

        } else {
            nav.style.top = (headerHeight + searchHeight) + 'px';
        }

        //Set max-height of Login wrap
        loginFormWrap.style.maxHeight = (windowHeight - headerHeight) + 'px';

        //Set position of aux elements
        searchBar.style.top = headerHeight + 'px';
        loginFormWrap.style.top = headerHeight + 'px';

        //Position utils links below nav on mobile
        if (window.innerWidth < 1200) {
            utilLinks.style.position = 'relative';
			nav.style.height = `calc(100vh - ${searchHeight}px - ${headerHeight}px)`;
        //Position util links above nav on desktop
        } else if (window.innerWidth >= 1200) {
            utilLinks.style.position = 'absolute';
            utilLinks.style.top = '0';
            nav.style.height = '100%';
        }
    }

    toggleMobileNav() {
        var header: HTMLElement = document.querySelector('header.site-header');
        var toggle: HTMLElement = document.querySelector('.mobile-nav-toggle');
        var utils: HTMLElement = document.querySelector('.site-header__utils');
        var nav: HTMLElement = document.querySelector('.app-nav');
        var utilLinks: HTMLElement = document.querySelector('.header-util-nav-links');
        //var loginFormWrap: HTMLElement = document.querySelector('#login-wrapper');
        //var loginMobileIcon: HTMLElement = document.querySelector('.login-mobile-icon');

        if (!toggle || !utils || !nav || !utilLinks) {
            return;
        }

        toggle.onclick = () => {
            this.calculateNavPositions();

            //Close Login if open
            /*
            if (loginMobileIcon.classList.contains('login-open') || loginFormWrap.classList.contains('login-open')) {
                loginMobileIcon.classList.remove('login-open');
                loginFormWrap.classList.remove('login-open');
                header.classList.remove('menu-open');
                document.querySelector('body').classList.remove('menu-open');
                document.documentElement.classList.remove('menu-open');
            }
            */
            
            utils.classList.toggle('open');
            nav.classList.toggle('open');
            toggle.classList.toggle('open');
            utilLinks.classList.toggle('open');
            header.classList.toggle('menu-open');
            document.querySelector('body').classList.toggle('menu-open');
            document.documentElement.classList.toggle('menu-open');
        };

        window.addEventListener('resize', () => {
            if (document.querySelector('body').classList.contains('menu-open') || document.documentElement.classList.contains('menu-open')) {
                this.calculateNavPositions();
            }
        });
    }

    searchKybrdCntrl() {
        var utilWrap: HTMLElement = document.querySelector('.site-header__utils');
        var searchBox: HTMLElement = document.querySelector('.search-text-box');

        if (utilWrap.classList.contains("search-open")) {
            searchBox.tabIndex = 0;
            searchBox.focus();
        } else {
            searchBox.tabIndex = -1;
            searchBox.blur();
        }
    }

    toggleDesktopSearch() {
        var loginDeskToggle: HTMLElement = document.querySelector('#login-desktop-btn');  
        var loginFormWrap: HTMLElement = document.querySelector('#login-wrapper');
        var searchToggle: HTMLElement = document.querySelector('#search-icon-desktop-nav');
        var utilWrap: HTMLElement = document.querySelector('.site-header__utils');
        var searchDescendants: NodeListOf<HTMLElement> = utilWrap.querySelectorAll('*');


        var checkSearchFocus = () => {
            let hasFocus = false;
          
            searchDescendants.forEach(element => {
                if (element === document.activeElement) {
                    hasFocus = true;
                }
            });
          
            if (hasFocus) {
                // Open Search if anything in the Search Wrapper has focus
                utilWrap.classList.add('search-open');
                searchToggle.classList.add('search-open');
                document.querySelector('body').classList.add('menu-open');
            } else {
                // Close Search if nothing in the Search Wrapper has focus
                utilWrap.classList.remove('search-open');
                searchToggle.classList.remove('search-open');
                document.querySelector('body').classList.remove('menu-open');
            }
        };

        //Event listeners to listen for focus or blur on elements in the Search Wrapper
        searchDescendants.forEach(descendant => {
            descendant.addEventListener('focus', () => {
                checkSearchFocus();
            });
            descendant.addEventListener('blur', () => {
                setTimeout(() => {
                    let hasFocus = false;
                    searchDescendants.forEach(element => {
                        if (element === document.activeElement) {
                            hasFocus = true;
                        }
                    });
            
                    if (!hasFocus) {
                        utilWrap.classList.remove('search-open');
                        searchToggle.classList.remove('search-open');
                        document.querySelector('body').classList.remove('menu-open');
                    }
                }, 250); // Delay to allow focus to move to another element
                });
        });
        ///*** END OPEN/CLOSE SEARCH ON KEYBOARD FOCUS/BLUR ***///

        searchToggle.onclick = () => {

            this.calculateNavPositions();

            //Close Login if open
            if (loginDeskToggle.classList.contains('login-open')) {
                loginDeskToggle.classList.remove('login-open');
                document.querySelector('body').classList.remove('menu-open');
            }
            if (loginFormWrap.classList.contains('login-open')) {
                loginFormWrap.classList.remove('login-open');
                document.querySelector('body').classList.remove('menu-open');
            }

            //Open/close Search
            utilWrap.classList.toggle('search-open');
            searchToggle.classList.toggle('search-open');
            document.querySelector('body').classList.toggle('menu-open');

            this.searchKybrdCntrl();
        };
    }

    toggleLogin() {
        var header: HTMLElement = document.querySelector('header.site-header');
        //var loginDeskToggle: HTMLElement = document.querySelector('#login-desktop-btn');  
        //var loginFormWrap: HTMLElement = document.querySelector('#login-wrapper');
        var loginMobileIcon: HTMLElement = document.querySelector('.login-mobile-icon');
        var nav: HTMLElement = document.querySelector('.app-nav');
        var utilWrap: HTMLElement = document.querySelector('.site-header__utils');
        var utilLinks: HTMLElement = document.querySelector('.header-util-nav-links');
        var mobileNavToggle: HTMLElement = document.querySelector('.mobile-nav-toggle');
        //var deskSearchIcon: HTMLElement = document.querySelector('#search-icon-desktop-nav');
        //var radioBtnFieldset: HTMLElement = document.querySelector('#radio-btn-fieldset');
        //var radioBtnWrap: HTMLElement = document.querySelector('.radio-wrap');
        //var focusableElements: NodeListOf<HTMLElement> = loginFormWrap.querySelectorAll('input, button, select, textarea, a[href]');

        // Close Login Form if none of the focuable elements have focus
        /*
        focusableElements.forEach(element => {
            element.addEventListener('blur', () => {
                setTimeout(() => {
                  let hasFocus = false;
                  focusableElements.forEach(element => {
                    if (element === document.activeElement) {
                      hasFocus = true;
                    }
                  });
            
                  if (!hasFocus) {
                    loginDeskToggle.classList.remove('login-open');
                    loginFormWrap.classList.remove('login-open');
                    radioBtnFieldset.setAttribute('disabled', 'disabled');
                    focusableElements.forEach(element => {
                        if (element.hasAttribute('tabindex')) {
                            if (element.tabIndex === 0) {
                                element.tabIndex = -1;
                            }
                        }
                    })
                    if (!utilWrap.classList.contains('search-open')) {
                        document.querySelector('body').classList.remove('menu-open');
                    }
                  }
                }, 375); // Delay to allow focus to move to another element
              });
        });
        */

        //Puts focus on the selected radio button option if the form is clicked anywhere that is not a focusable element, which prevents the Login Form from closing as a result of the focusableElements forEach loop above
        /*
        loginFormWrap.addEventListener('click', (event) => {
            var target = event.target as HTMLElement;
            if (!target.closest('input, button, select, textarea, a[href]')) {
                let selectedRadioBtn: HTMLInputElement | null = document.querySelector('.login-radio:checked');
                selectedRadioBtn.focus();
            }
        });
        */

        loginMobileIcon.onclick = () => {
            this.calculateNavPositions();

            //Close mobile nav if open
            if (utilWrap.classList.contains('open') || nav.classList.contains('open') || utilLinks.classList.contains('open') || mobileNavToggle.classList.contains('open')) {
                utilWrap.classList.remove('open');
                nav.classList.remove('open');
                utilLinks.classList.remove('open');
                mobileNavToggle.classList.remove('open');
                header.classList.remove('menu-open');
                document.querySelector('body').classList.remove('menu-open');
                document.documentElement.classList.remove('menu-open');
            }

            //document.querySelector('body').classList.toggle('menu-open');
            //loginMobileIcon.classList.toggle('login-open');
            //loginFormWrap.classList.toggle('login-open');
        };
    }

    render() {
        return (
            <nav class="app-nav">
                {this.pageNodeArray.map((node, nodeIndex) => (
                    <div class="app-nav__node" onMouseEnter={() => {this.menuEntered('enter')}} onMouseLeave={() => {this.menuEntered('leave')}}>
                        <div class="app-nav__parent" aria-label={node.Title}>
                            {Boolean(node.UrlName) ? ( 
                                <a href={node.UrlName} class={(node.LinkSpeedbump ? 'speedbump-link' : '')} target={node.LinkNewTab ? '_blank' : ''} aria-label={node.Title}>
                                    { node.Title }
                                </a>
                                ):(
                                <div>{node.Title}</div>
                            )}

                            {Boolean(node.Nodes && node.Nodes.length) && (
                                <button class="app-nav__parent-toggle" role="button" tabIndex={0} aria-label="Toggle Navigation Item" onClick={() => {this.mobileNavToggle('1', nodeIndex)}}>
                                    <kdx-icon icon="triangle-down" class="desk-nav-arrow"></kdx-icon>
                                    <kdx-icon icon="plus" class="open"></kdx-icon>
                                    <kdx-icon icon="remove" class="close"></kdx-icon>
                                </button>
                            )}
                        </div>

                        {(Boolean(node.Nodes && node.Nodes.length) && this.hasThirdLevel(node.Nodes)) && (
                            <div class={`app-nav__sub mega-children ${(node.Nodes.some(child => child.Break === 'true')) ? '' : 'no-break'}`}>
                                <div class="app-nav__children">
                                    <div class="row" innerHTML={this.createChildrenMarkup(node.Nodes)}>
                                    </div>
                                </div>

                                <div class="app-nav__children-mobile">
                                    {node.Nodes.map((child, childIndex) => (
                                        <div class="app-nav__child">
                                            <div class="app-nav__child-link">
                                                <a href={child.UrlName} class={(child.LinkSpeedbump ? 'speedbump-link' : '')} target={child.LinkNewTab ? '_blank' : ''} aria-label={child.Title}>
                                                    { child.Title }
                                                </a>

                                                {Boolean(child.Nodes && child.Nodes.length) && (
                                                    <button class="app-nav__parent-toggle" role="button" tabIndex={0} aria-label="Toggle Navigation Item" onClick={() => {this.mobileNavToggle('2', nodeIndex, childIndex)}}>
                                                        <kdx-icon icon="plus" class="open"></kdx-icon>
                                                        <kdx-icon icon="remove" class="close"></kdx-icon>
                                                    </button>
                                                )}
                                            </div>

                                           {Boolean(child.Nodes && child.Nodes.length) && (
                                                <div class="app-nav__third-level">
                                                    {child.Nodes.map((thirdLevel) => (
                                                        <a href={thirdLevel.UrlName} class={(thirdLevel.LinkSpeedbump ? 'speedbump-link' : '')} target={thirdLevel.LinkNewTab ? '_blank' : ''} aria-label={thirdLevel.Title}>
                                                            { thirdLevel.Title }
                                                            <kdx-icon icon="thin-chevron"></kdx-icon></a>
                                                    ))}
                                                </div>
                                           )}
                                        </div>
                                    ))}
                                </div>

                                {Boolean(node.CTA) && (
                                    <kdx-mega-nav-cta CTA={node.CTA}></kdx-mega-nav-cta>
                                )}
                            </div>
                        )}

                        {(Boolean(node.Nodes && node.Nodes.length) && !this.hasThirdLevel(node.Nodes)) && (
                            <div class={{
								"app-nav__sub": true,
								"simple-children": true,
								"has-cta": Boolean(node.CTA)
							}}>
                                <div class="simple-children__links">
                                    {node.Nodes.map((child) => (
                                        <a href={child.UrlName} class={(child.LinkSpeedbump ? 'speedbump-link' : '')} target={child.LinkNewTab ? '_blank' : ''} aria-label={child.Title}>
                                            { child.Title }
                                            <kdx-icon icon="thin-chevron"></kdx-icon>
                                        </a>
                                    ))}
                                </div>

                                {Boolean(node.CTA) && (
                                    <kdx-mega-nav-cta CTA={node.CTA}></kdx-mega-nav-cta>
                                )}
                            </div>
                        )}
                    </div>
                ))}
                <section class="header-util-nav-links">
                    <span class="routing-number">Routing: 211370888</span>
                {Boolean(this.utilityNavLinkArray && this.utilityNavLinkArray.length) && (    
                    this.utilityNavLinkArray.map((link) => (
                        <a href={link.UrlName} class={(link.LinkSpeedbump ? 'util-link speedbump-link' : 'util-link')} target={link.LinkNewTab ? '_blank' : ''} aria-label={link.Title}>
                            {link.Title}<span><img src={link.IconUrl} alt={link.IconAlt}/></span>
                        </a>
                    ))
                )}
                </section>
            </nav>
        );
    }
}
